import type { Theme, Components } from "@mui/material/styles";
import { InputSelectIcon } from "./CustomIcons";

// ----------------------------------------------------------------------

export default function Select(): Components<Theme> {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: InputSelectIcon,
      },
    },
  };
}
